import React, { useEffect, useMemo, useState } from "react";
import { IoIosPaper } from "react-icons/io";
import Cookies from "js-cookie";
import moment from "moment";
import qs from "qs";

import { useHistory } from "react-router-dom";
import { AxiosCustomGet } from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import CustomDatePicker from "../../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../../components/common/Table/CustomTable";
import TextInput from "../../../../components/common/TextInput/TextInput";
import Title from "../../../../components/common/Title/Title";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";

import SwalToast from "../../../../components/helpers/SwalToast";
import {
  refundInitFilterInput,
  renderRefundExpiredColumns,
} from "../constants";

import "../../styles.css";
import { convertRefundExpired } from "../helpers";

const RefundExpired = () => {
  const history = useHistory();
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [searchNameValue, setSearchNameValue] = useState("");
  const [dateValue, setDateValue] = useState([]);
  const [refundList, setRefundList] = useState([]);
  const [filterInput, setFilterInput] = useState(refundInitFilterInput);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [totalTransactions, setTotalTransactions] = useState(0);

  const handleViewDetail = (record) => {
    history.push(`/report/pawn/${record.gadaiID || 0}`);
  };

  const getRefundExpiredList = () => {
    setLoading(true);
    const data = {
      query: filterInput.searchName,
      start_date_transaction: filterInput.transactionStartDate,
      end_date_transaction: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
      status: "canceled",
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}refund/request`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);

        setTotalTransactions(response.data.data.total_item);
        setRefundList(convertRefundExpired(response.data.data.items));
        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "pageSize") {
      setPageSizeValue(value);
    } else if (name === "searchName") {
      setSearchNameValue(value);
    }
  };

  const dataPdf = useMemo(() => {
    const temp = refundList.map(
      ({ transferProof, approvalProof, ...item }) => item
    );
    return temp;
  }, [refundList]);

  const handleEnter =
    (type = "enter") =>
      (event) => {
        const { name, value } = event.target;

        if (event.keyCode === 13 || type === "blur") {
          if (name === "pageSize" && value === "") {
            setPageSizeValue(10);
          }
          setFilterInput((prev) => ({
            ...prev,
            [name]: name === "pageSize" && value === "" ? 10 : value,
            page: 1,
          }));
        }
      };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");
    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const handleExport = (type) => (e) => {
    if (type === "excel") {
      handleExportExcel();
    }
  };

  const handleExportExcel = () => {
    const data = {
      query: filterInput.searchName,
      date_start: filterInput.transactionStartDate,
      date_end: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}report/refund/excel`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "pengembalian_dana.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
            ? "DESC"
            : null,
    }));
  };

  const getMonthly = () => {
    let startOfMonth = moment().startOf("month");
    let endOfMonth = moment();

    setDateValue([startOfMonth, endOfMonth]);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: new Date(startOfMonth),
      transactionEndDate: new Date(endOfMonth),
    }));
  };

  useEffect(() => {
    getRefundExpiredList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterInput]);

  useEffect(() => {
    getMonthly();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Pengembalian Dana Kadaluwarsa"} />
            <Breadcrumb current={"Pengembalian Dana Kadaluwarsa"} />
          </div>
          <div className="ml-auto d-flex align-items-center">
            <div className="total-container">
              <IoIosPaper className="total-icon" />{" "}
              <span style={{ fontWeight: "bold" }}>{totalTransactions}</span>{" "}
              Transaksi
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between filter-bar-2">
          <TextInput
            id={"pageSize"}
            label={"Tampilkan"}
            width={"7%"}
            handleEnter={handleEnter}
            value={pageSizeValue}
            handleChange={handleTextInputChange}
          />
          <TextInput
            id={"searchName"}
            label={"No. SBG / No. Kwitansi / Nama Nasabah"}
            width={"30%"}
            placeholder={"Cari.."}
            handleEnter={handleEnter}
            value={searchNameValue}
            handleChange={handleTextInputChange}
          />
          <CustomDatePicker
            id={"capitalTransaction"}
            label={"Tanggal Transaksi"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={dateValue}
          />
          <div className="ml-auto d-flex align-items-center">
            {/* <Button
              variant="primary"
              className="btn-action btn-add"
              onClick={handleOpenAddDialog}
            >
              + Tambah Transaksi
            </Button> */}
          </div>
        </div>

        <CustomTable
          columns={renderRefundExpiredColumns(handleViewDetail)}
          // scrollX={2000}
          data={refundList}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
        />

        {/* <div className="filter-bar-2 d-flex " style={{ marginTop: "2rem" }}>
          <ExportButton
            handleExport={handleExport}
            pathname="/report/refund/export"
            data={dataPdf}
            from="report"
            columns={renderRefundColumns(null, null, false)}
          />
        </div> */}
      </div>
    </div>
  );
};

export default RefundExpired;
